<template>
    <div class="tab" :class="{'is-active': isActive}">
        <h2 class="visible-xs-block">{{ title }}</h2>
        <slot></slot>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isActive: false
        }
    },
    props: {
        name: {required: true},
        title: {required: true},
        selected: {default: false}
    },
    mounted() {
        this.isActive = this.selected
    }
}
</script>